export const ENV = import.meta.env.VITE_ENV
export const API_URL = import.meta.env.VITE_API_URL
export const MAP_ACCESS_TOKEN = import.meta.env.VITE_MAP_ACCESS_TOKEN
export const MAP_STYLE = import.meta.env.VITE_MAP_STYLE
export const CHART_DESCRIPTION_PUBLIC_URL = import.meta.env.VITE_CHART_DESCRIPTION_PUBLIC_URL
